import { Link, Text } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import * as Styled from './styles'

interface SavingOverlayProps {
  disabled?: boolean
  isSavingFinished: boolean
  itemsToSaveCount: number
  onClose(): void
  shouldDisplay: boolean
  savedCount: number
}

export const SavingOverlay = ({
  disabled,
  isSavingFinished,
  itemsToSaveCount,
  onClose,
  shouldDisplay,
  savedCount,
}: SavingOverlayProps): ReactElement | null => {
  const { t } = useTranslation()

  if (!shouldDisplay) {
    return null
  }

  return (
    <Styled.SavingContainer>
      <Text weight="medium" variant="bodyLG">
        {isSavingFinished ? t('attachments.uploading_complete') : t('attachments.uploading')}
      </Text>
      <Text>
        <Trans
          i18nKey="attachments.upload_stats"
          count={itemsToSaveCount}
          values={{
            count: itemsToSaveCount,
            savedCount,
          }}
        >
          Uploaded <strong>{savedCount}</strong> of <strong>{itemsToSaveCount}</strong> file.
        </Trans>
      </Text>
      {isSavingFinished && !disabled && (
        <Text weight="medium" variant="bodyLG">
          <Link onClick={onClose}>{t('attachments.close')}</Link>
        </Text>
      )}
    </Styled.SavingContainer>
  )
}
